export default __webpack_public_path__ + "media/search/heart-9cbf22b6.svg";